import React from 'react'

function UserFamilyPage() {
  return (
    <div>UserFamilyPage</div>
  )
}

export default UserFamilyPage;